export const faqs = [
  {
    question: "What is [Your Company Name] School Management Software?",
    answer:
      "Our school management software is an all-in-one platform designed to simplify administrative tasks, enhance communication, and improve the overall educational experience. It includes features for managing attendance, grades, timetables, fees, and much more—making it easier for schools to operate efficiently while keeping students and parents engaged.",
  },

  {
    question: "How does the Parent App work?",
    answer:
      "The Parent App allows parents to stay connected with their child's school activities. Through the app, parents can track academic progress, view attendance records, monitor homework assignments, and receive updates on upcoming events. Additionally, the app includes an AI-powered tutor, offering personalized learning support for students anytime, anywhere.",
  },

  {
    question: "Can the software be customized for different types of schools?",
    answer:
      "Yes! Our platform is highly customizable to meet the specific needs of any educational institution—whether it's a small private school, a large public school, or even a network of schools. We offer flexible configurations for features like attendance, grading, and fee management, ensuring the software aligns with your school’s workflow.",
  },

  {
    question: "Is the software easy to use for both educators and parents?",
    answer:
      "Absolutely! We’ve designed our platform to be user-friendly and intuitive. Both educators and parents can easily navigate the system, with minimal training required. The interface is simple yet powerful, ensuring that everyone—from teachers to administrators and parents—can make the most of the software’s features.",
  },

  {
    question: "How does the AI tutor work in the Parent App?",
    answer:
      "The AI tutor in the Parent App provides personalized academic assistance to students by offering real-time help with homework, clarifying concepts, and providing additional practice on subjects where they need extra support. It adapts to each student’s learning style, ensuring a tailored approach to their educational needs.",
  },

  {
    question: "Is the platform secure?",
    answer:
      "Yes, security is a top priority for us. Our platform uses state-of-the-art encryption protocols and follows strict data protection regulations to ensure that all sensitive information—such as student data, grades, and financial details—is kept safe and secure.",
  },

  {
    question: "Can our school try the software before committing?",
    answer:
      "We offer live demos and trials so that you can explore the full capabilities of our school management software before making a decision. Our team is happy to walk you through the platform, answer ,any questions, and help you understand how it can benefit your school.",
  },
];
